'use client';
import React from 'react';
import { sendTealiumEvent } from '~/utils/tealium';
import { EVENT_WMAP_ORDER_CALL_CLICK } from '~/constant/constants';
interface IPhoneLinkProps {
  label: string;
  id: string;
  phoneNumber: string;
  eventDescription?: string;
}
const PhoneLink: React.FC<IPhoneLinkProps> = ({
  label,
  id,
  phoneNumber,
  eventDescription,
}) => {
  const handlePhoneClick = () => {
    sendTealiumEvent({
      event: 'call-engagement',
      event_category: 'call',
      event_noninteraction: 'false',
      event_type: 'call_engagement',
      event_action: eventDescription || EVENT_WMAP_ORDER_CALL_CLICK,
      event_label: 'call engagement',
    });
  };
  return (
    <a id={id} onClick={handlePhoneClick} href={`tel:${phoneNumber}`}>
      {label}
    </a>
  );
};

export default PhoneLink;
